import "./App.css";

import HomePage from "./pages/HomePage/HomePage";
import NewBill from "./pages/NewBill/NewBill";
import ListBills from "./pages/ListBills/ListBills";
import Dashboard from "./pages/Dashboard/Dashboard";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import NewUserForm from "./pages/NewUserForm/NewUserForm";
import ListLearnersPage from "./pages/ListLearners/ListLearners";
import ListLearnersPresencePage from "./pages/ListLearnersPresence/ListLearnersPresence";
import Sections from "./pages/Sections/Sections";
import EditLearner from "./pages/EditLearner/EditLearner";
import PatrolmeterEdit from "./pages/PatrolmeterEdit/PatrolmeterEdit";
import Patrolmeter from "./pages/Patrolmeter/Patrolmeter";

import { Routes, Route, Navigate } from "react-router-dom";
import Loading from "./components/Loading/Loading";
import Toast from "./components/Toast/Toast";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { AuthContext } from "./contexts/auth.context";
import { useContext } from "react";
import { ROLES } from "./constants";

function App() {
  const { isLoading } = useContext(AuthContext);

  return (
    <div className="App">
      <Toast />
      {isLoading && <Loading />}
      <Routes>
        {/* Ruta pública - Login */}
        <Route path="/" element={<HomePage />} />

        {/* Rutas protegidas - Solo autenticados */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/newbill"
          element={
            <ProtectedRoute>
              <NewBill />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sections"
          element={
            <ProtectedRoute>
              <Sections />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listLearners/:section"
          element={
            <ProtectedRoute>
              <ListLearnersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/editLearner/:id"
          element={
            <ProtectedRoute>
              <EditLearner />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listLearnersPresence/:section"
          element={
            <ProtectedRoute>
              <ListLearnersPresencePage />
            </ProtectedRoute>
          }
        />
        <Route path="/patrolmeter" element={<Patrolmeter />} />
        <Route path="/patrolMeter" element={<Navigate to="/patrolmeter" replace />} />
        <Route
          path="/patrolmeterEdit"
          element={
            <ProtectedRoute>
              <PatrolmeterEdit />
            </ProtectedRoute>
          }
        />
        <Route path="/patrolMeterEdit" element={<Navigate to="/patrolmeterEdit" replace />} />

        {/* Rutas con roles específicos */}
        <Route
          path="/listbills"
          element={
            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.TREASURER]}>
              <ListBills />
            </ProtectedRoute>
          }
        />
        <Route
          path="/newUserForm"
          element={
            <ProtectedRoute allowedRoles={[ROLES.ADMIN]}>
              <NewUserForm />
            </ProtectedRoute>
          }
        />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
